import { useContext, useState } from "react";
import UiContext from "../../../../../store/ui-context";
import useAPIRequest from "../../../../../custom_hooks/simple/useAPIRequest";

export const useAPIEditOfferRewardFree = (props) => {
  const { onConfirmed } = props;

  const uiContext = useContext(UiContext);
  const { requestGetOne, requestPost, loading } = useAPIRequest();

  const [data, setData] = useState({});
  const [error, setError] = useState({});

  //  API call section

  const fetchData = async ({ id, extraData }) => {
    return requestGetOne({
      fullUrl: `/api/customer/customerfreeproduct/one/${id}`,
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data: _data, message }) => {
        const newData = reformatDataAfterFetch(_data);
        if (extraData) {
          setData({ ...extraData, ...newData });
        } else {
          setData(newData);
        }
      },
    });
  };

  const saveData = async () => {
    setError({});

    return requestPost({
      fullUrl: `/api/customer/customerfreeproduct/save`,
      body: reformatDataBeforeSave(data),
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data: _data, message }) => {
        uiContext.showSuccessMsg("Success", message);
        const newData = reformatDataAfterFetch(_data);
        onConfirmed(newData);
      },
    });
  };

  // other function section

  const validate = () => {
    let valid = true;
    let newError = {};

    // if (!data.customer_id) {
    //   valid = false;
    //   newError = { ...newError, customer_id: "Customer harus isi" };
    // }

    if (!data.product_id) {
      valid = false;
      newError = { ...newError, product_id: "Product harus isi" };
    }

    // if (!data.requested_quantity || data.requested_quantity <= 0) {
    //   valid = false;
    //   newError = { ...newError, requested_quantity: "Requested quantity harus lebih dari 0" };
    // }

    setError(newError);
    return valid;
  };

  const reformatDataBeforeSave = (_data) => {
    const newData = data;

    return newData;
  };

  const reformatDataAfterFetch = (_data) => {
    return _data;
  };

  const fetchDataOrCreateNew = ({ id, extraData }) => {
    if (id && id > 0) {
      fetchData({ id, extraData });
    } else {
      if (extraData) {
        setData({ ...generateNewData(), ...extraData });
      } else {
        setData(generateNewData());
      }
    }
  };

  const generateNewData = () => {
    return {
      // PART FIELDS
      provinsi_id: '',
      kode: '',
      nama: '',
    };
  };

  // handle ui event section

  const handleOnConfirm = () => {
    const valid = validate();
    if (valid) {
      saveData();
    }
  };

  return {
    loading,
    data,
    setData,
    error,
    fetchDataOrCreateNew,
    handleOnConfirm,
    onConfirmed,
  };
};
